// Shimmer version of SideBarLayout's chrome (SideBar.js + top-nav).
export default function SideBarShellSkeleton({ children }) {
    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#FAFAFA' }}>
            {/* Sidebar */}
            <div style={{
                width: 220, flexShrink: 0, background: '#FFFFFF', borderRight: '1px solid #E2E8F0',
                display: 'flex', flexDirection: 'column', padding: '13px 14px 10px',
            }} className="d-none d-lg-flex">
                <div style={{ display: 'flex', alignItems: 'center', gap: 9, paddingBottom: 10, borderBottom: '1px solid #E2E8F0', marginBottom: 10 }}>
                    <div className="shine rounded-2" style={{ width: 28, height: 28, flexShrink: 0 }} />
                    <div className="shine rounded-2" style={{ width: 90, height: 14 }} />
                </div>
                <div className="shine rounded-3" style={{ height: 36, marginBottom: 14 }} />
                {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} className="shine rounded-2" style={{ height: 28, marginBottom: 6, width: `${80 - i * 6}%` }} />
                ))}
                <div style={{ flex: 1 }} />
                <div className="shine rounded-3" style={{ height: 34, marginTop: 10 }} />
            </div>

            {/* Main column */}
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                {/* Top bar */}
                <div style={{
                    height: 60, flexShrink: 0, background: '#FFFFFF', borderBottom: '1px solid #F1F5F9',
                    display: 'flex', alignItems: 'center', padding: '0 14px', gap: 8,
                }}>
                    <div className="shine rounded-2 d-lg-none" style={{ width: 38, height: 38, flexShrink: 0 }} />
                    <div style={{ flex: 1 }} />
                    <div className="shine rounded-3 d-none d-md-block" style={{ width: 100, height: 34 }} />
                    <div className="shine rounded-3 d-none d-md-block" style={{ width: 80, height: 34 }} />
                    <div className="shine rounded-3" style={{ width: 34, height: 34 }} />
                    <div className="shine rounded-circle" style={{ width: 32, height: 32, flexShrink: 0 }} />
                </div>

                {/* Content */}
                <div style={{ flex: 1, padding: 16, display: 'flex', justifyContent: 'center' }}>
                    <div style={{ maxWidth: 1000, width: '100%' }}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
